import React, { useState, useContext, useEffect } from 'react';
import { useUser } from '../UserContext';

import { Button, IconButton, Typography, Tooltip } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';

import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { signInWithRedirect, signOut, getCurrentUser, fetchUserAttributes, fetchAuthSession } from 'aws-amplify/auth';
import config from '../../amplifyconfiguration.json';

console.log(config);

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const [
  localRedirectSignIn,
  testRedirectSignIn,
] = config.oauth.redirectSignIn.split(",");

const [
  localRedirectSignOut,
  testRedirectSignOut,
] = config.oauth.redirectSignOut.split(",");

const updatedConfig = {
  ...config,
  oauth: {
    ...config.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : 
      // isTestServer? testRedirectSignIn : prodRedirectSignIn,
      testRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : 
      // isTestServer? testRedirectSignOut : prodRedirectSignOut,
      testRedirectSignOut,
  }
}

Amplify.configure(updatedConfig);

const AuthButton = () => {
  const {user, setUser} = useUser();
  const [error, setError] = useState(null);
  const [customState, setCustomState] = useState(null);
  
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signInWithRedirect':
          getUser();
          break;
        case 'signInWithRedirect_failure':
          setError('An error has ocurred during the Oauth flow.');
          break;
        case 'customOAuthState':
          setCustomState(payload.data);
          break;
      }
    });
    getUser();
    return unsubscribe;
  }, []);

  const getUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      const userInfo = await fetchUserAttributes();
      const session = await fetchAuthSession();
      currentUser['usergroups'] = session?.tokens?.idToken?.payload["cognito:groups"];
      currentUser['attributes'] = userInfo;
      setUser(currentUser);
    } catch (error) {
      console.log('Not signed in');
    }
  };
 
  return ( 
    <div style={{"display": "flex", "justifyContent": "right", "color": "#AAA"}}>
      {user ? (
        <div> 
          <span>{user.attributes.email}</span>
          <IconButton color="inherit" onClick={() => signOut()}>
            <LoginIcon />
          </IconButton>
        </div>
      ) : (
        <div> 
          <span>Sign in using Google account</span>
          <IconButton color="inherit" onClick={() => signInWithRedirect(
            { provider: 'Google' })} >
            <LoginIcon />
          </IconButton>
        </div>
      )}
    </div>
  )
}

export default AuthButton;
